import React, { useEffect, useRef, useState, useMemo } from "react";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import SubNav from "../../../navbar/subNav";
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import { Button, message } from "antd";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { bankfiletransactionlist, searchtenantforreceipt, getviewreceiptdetails, cancelbanktransaction, addrentreceipt } from "../../../../components/CommonSection/apiresources";
import { ActionStatus } from "../../../../Utilities/enum";
import moment from "moment";
import debounce from "lodash/debounce";
import NewTenantReceipt from "../newReceipt";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { Dropdown, Menu } from "antd";
import { DownOutlined, CloseOutlined } from "@ant-design/icons";
import "./transaction.css"


const ReconcileTransaction = () => {
    const ToastRef = useRef();
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [activeTab, setActiveTab] = useState("All");
    const [transactions, setTransactions] = useState([]);
    const [ppenAddNewReceipt, setOpenAddNewReceipt] = useState(false);
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(4);
    const [rentData, setRentData] = useState([
        { allocation: "Rent", due: "21 Sep 2024", description: "Paid to 21/09/2024", amountDue: "13 days", amount: "" }
    ]);
    const [depositData, setDepositData] = useState([
        { description: "", amount: "" }
    ]);
    const ePaymentModes = [
        { value: 1, label: "Cash" },
        { value: 2, label: "Cheque" },
        { value: 3, label: "Card" },
        { value: 4, label: "EFT" }
    ];
    const [amount, setAmount] = useState(0);
    const [rentAmount, setRentAmount] = useState(null);
    const [receiptDetails, setReceiptDetails] = useState({});
    const [supplierValue, setSupplierValues] = useState("");
    const [tenantValue, setTenantValues] = useState("");
    const [fetchingSupplier, setFetchingSupplier] = useState(false);
    const [optionSupplier, setOptionSupplier] = useState([]);
    const [selectedTransactionAmount, setSelectedTransactionAmount] = useState(0);
    const [agencyID, setAgencyId] = useState("");
    const [auditNo, setAuditNo] = useState(0);
    const [userId, setUserId] = useState("");
    const [bankFileTransactionId, setBankFileTransactionId] = useState(null)
    var url = new URL(window.location.href);
    var fileId = url.searchParams.get("fileId");
    const [invoiceAmounts, setInvoiceAmounts] = useState([]);
    const [matchedCount, setMatchedCount] = useState(0);
    const [unmatchedCount, setUnmatchedCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);


    const fetchRef = useRef(0);

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        getReconcileList(fileId, 1);
    }, []);

    const getReconcileList = async (fileId, id) => {
        try {
            const data = { FileId: parseInt(fileId), TabId: id };
            const response = await makeRequestWithSpinner(showSpinner, hideSpinner, bankfiletransactionlist, "post", data);

            if (response.status === ActionStatus.Successfull) {
                const allTransactions = response.object.transactions;
                const creditTransactions = allTransactions;

                const matchedTransactions = creditTransactions.filter(tx => tx.matchingDetails?.isMatched);
                const unmatchedTransactions = creditTransactions.filter(tx => !tx.matchingDetails?.isMatched);

                setTransactions(creditTransactions);
                setTotalCount(response.object.totalCount || creditTransactions.length);
                setUnmatchedCount(response.object.unmatchedCount || unmatchedTransactions.length);
                setMatchedCount(response.object.matchedCount || matchedTransactions.length); // 👈 Add this state
            }
            else {
                message.error(response.message);
                ToastRef.current.notify(["error", response.message]);
            }
        } catch (error) {
            console.error("Error fetching reconcile data:", error);
            ToastRef.current.notify(["error", "An error occurred while loading transactions."]);
        }
    };
    const tabs = [
        { label: "All", count: totalCount },
        { label: "Unmatched", count: unmatchedCount },
        { label: "Matched", count: matchedCount },
    ];
    const handleTabs = (tab) => {
        setActiveTab(tab);
        let tabId = 1;
        if (tab === "Unmatched") tabId = 2;
        else if (tab === "Matched") tabId = 3;

        getReconcileList(fileId, tabId);
    };

    const handleOpenReceipt = (amount, id, postedDate, propertyId = null, matchedTenant = null) => {
        setOpenAddNewReceipt(true);
        setSelectedTransactionAmount(amount);
        setBankFileTransactionId(id);
        setDate(moment(postedDate).format("YYYY-MM-DD"));

        if (propertyId) {
            setAuditNo(propertyId);
            setSupplierValues(propertyId);

            // ✅ Set tenantValue for Select
            if (matchedTenant) {
                const tenantOption = {
                    value: propertyId,
                    label: `${matchedTenant.tenantName} (${matchedTenant.folio?.trim()})`,
                    title: `${matchedTenant.tenantName} (${matchedTenant.folio?.trim()})`
                };
                setTenantValues(tenantOption);
            }

            viewreceiptdetails(propertyId);
        }
    };


    const closeReceipt = () => {
        setOpenAddNewReceipt(false);
        setReceiptDetails({});
        setAmount(0);
        setRentAmount(null);
        setInvoiceAmounts([]);
        setDepositData([{ description: "", amount: "" }]);
        setSupplierValues("");
        setTenantValues("");
        setRentData([
            {
                allocation: "Rent",
                due: "",
                description: "",
                amountDue: "",
                amount: ""
            }
        ]);
        setDate(moment().format('YYYY-MM-DD'));
    };


    const handleSearchSupplier = (value) => {
        debounceFetcherSupplier(value);
        setSupplierValues(value.value);
        viewreceiptdetails(value.value);
        setAuditNo(value.value)
        setTenantValues(value.title)
    };

    const handleClearSupplier = () => {
        setSupplierValues("");
        setRentData([]);
        setReceiptDetails([]);
    };

    const handleReceiptSubmit = (formData, amt, bankTxId, propertyId, date) => {
        const payload = {
            Id: 0,
            Type: 1,
            Date: date,
            PaymentMode: selectedPaymentMode,
            Description: receiptDetails.propertyAddress,
            PropertyId: propertyId || auditNo, // 🟡 fallback if not passed
            AgencyId: agencyID,
            UserId: userId,
            BankFileTransactionId: bankTxId || bankFileTransactionId,
            ...(formData !== "matched" ? formData : { RentAmount: amt, Amount: amt }),
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, addrentreceipt, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    closeReceipt();
                    let tabId = 1;
                    if (activeTab === "Unmatched") tabId = 2;
                    else if (activeTab === "Matched") tabId = 3;
                    getReconcileList(fileId, tabId);
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            });
    };


    const viewreceiptdetails = (value) => {
        const baseUrl = getviewreceiptdetails;
        const apiUrl = `${baseUrl}?PropertyId=${value}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setReceiptDetails(response.object)
                    setDepositData([
                        {
                            description: `Deposit for ${response.object.propertyAddress}`,
                            amount: ""
                        }
                    ]);
                } else {
                    //handleparentsuccess(["warn", response.data.message]);
                }
            })
            .catch((error) => {
                //handleparentsuccess(["error", error]);
            });
    };


    const debounceFetcherSupplier = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptionSupplier([]);
            setFetchingSupplier(true);
            const baseUrl = searchtenantforreceipt;
            const data = {
                Search: value,
                RecordsPerPage: 10,
                PageNo: 1
            };

            makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                baseUrl,
                "post",
                data,
                "",
                false
            )
                .then((response) => {
                    if (response.status === 1) {
                        let supplierListData = response.list;
                        // Transform data to match Select options
                        const transformedData = supplierListData.map((item) => ({
                            label: `${item.tenantReference} ${item.name} (${item.tenantAccountFolio})`,
                            value: item.id,
                            title: item.tenantReference + `(${item.tenantAccountFolio})`
                        }));

                        // Update options and fetching state
                        if (fetchId === fetchRef.current) {
                            setOptionSupplier(transformedData);
                            setFetchingSupplier(false);
                        }
                    } else {
                        setFetchingSupplier(false);
                    }
                })
                .catch((error) => {
                    setFetchingSupplier(false);
                });
        };
        return debounce(loadOptions, 800);
    }, []);

    const actionsMenu = (
        <Menu
            items={[
                {
                    key: "refresh",
                    label: <span onClick={() => getReconcileList(fileId, 1)}>Refresh Matches</span>,
                },
                // Add more actions here later if needed
            ]}
        />
    );

    const handleDismiss = (id) => {
        const payload = {
            TransactionId: id,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, cancelbanktransaction, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    ToastRef.current.notify(["success", res.message]);
                    getReconcileList(fileId, 1);
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
    };


    const receiptMenu = (tx) => (
        <Menu onClick={({ key }) => {
            if (key === "somethingElse") handleOpenReceipt(tx.amount.toFixed(2), tx.id, tx.datePosted, tx.matchingDetails.propertyId, tx.matchingDetails);
            else if (key === "anotherTenant") handleOpenReceipt(tx.amount.toFixed(2), tx.id, tx.datePosted);
        }}>
            <Menu.Item key="somethingElse">↥ Receipt as something else</Menu.Item>
            <Menu.Item key="anotherTenant">↥ Receipt to another tenant</Menu.Item>
        </Menu>
    );

    console.log(transactions,'transactions')

    return (
        <div className="col-12 px-0 changedateantdstyle">
            <div className="col-12 px-0 daily-date-style">
                <SubNav title={"Process Bank Statement"} goback={true} extraData={true} />
                <ToastAlert ref={ToastRef} />

                <div className="material-work-desk-new bg-white m-3 p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5>Process Bank Statement</h5>
                        <Dropdown overlay={actionsMenu} trigger={['click']}>
                            <Button style={{ background: "#155C75", color: 'white' }}>
                                Actions <DownOutlined />
                            </Button>
                        </Dropdown>
                    </div>

                    <div className="d-flex justify-content-between border-bottom pb-1 mb-3" style={{ background: 'whitesmoke' }}>
                        <div style={{ display: "flex", padding: "5px", margin: '5px 15px' }}>
                            {tabs.map((tab) => (
                                <div
                                    key={tab.label}
                                    className={`button ${activeTab === tab.label ? "active-tab" : ""}`}
                                    onClick={() => handleTabs(tab.label)}
                                >
                                    {`${tab.label} (${tab.count})`}
                                </div>
                            ))}

                        </div>
                    </div>

                    {transactions.map((tx) => (
                        <div key={tx.id} className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                            <div style={{ cursor: "pointer", color: "red", marginRight: "8px" }} onClick={() => handleDismiss(tx.id)}>
                                <CloseOutlined />
                            </div>
                            <div className="border rounded bg-light p-3" style={{ flex: 1, minHeight: "100%" }}>
                                <div className="d-flex justify-content-between">
                                    <div className="fw-bold">{moment(tx.datePosted).format("D/MM/YYYY")}</div>
                                    <div className={`fw-bold ${tx.type === 'CREDIT' ? 'text-success' : 'text-warning'}`}>${tx.amount.toFixed(2)} {tx.type}</div>
                                </div>
                                <div className="text-muted mt-2">{tx.description}</div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                {(tx.matchingDetails?.isMatched || tx.matchingDetails?.isSuggested) ? (
                                    <Button.Group className={`receipt-button ${tx.matchingDetails?.isMatched
                                        ? "receipt-blue"
                                        : tx.matchingDetails?.isSuggested
                                            ? "receipt-orange"
                                            : "receipt-white"
                                        }`}>
                                        <Button
                                            className={`receipt-button ${tx.matchingDetails?.isMatched
                                                ? "receipt-blue"
                                                : tx.matchingDetails?.isSuggested
                                                    ? "receipt-orange"
                                                    : "receipt-white"
                                                }`}
                                            onClick={() => {
                                                if (tx.matchingDetails?.isMatched) {
                                                    handleReceiptSubmit("matched", tx.amount.toFixed(2), tx.id, tx.matchingDetails.propertyId, tx.datePosted);
                                                } else {
                                                    handleOpenReceipt(tx.amount.toFixed(2), tx.id, tx.datePosted, tx.matchingDetails.propertyId, tx.matchingDetails);
                                                }
                                            }}
                                        >
                                            {tx.matchingDetails?.isMatched ? "↥ Receipt" : "↥ Receipt as rent"}
                                        </Button>
                                        <Dropdown overlay={receiptMenu(tx)} trigger={['click']}>
                                            <Button className={`receipt-button ${tx.matchingDetails?.isMatched
                                                    ? "receipt-blue"
                                                    : tx.matchingDetails?.isSuggested
                                                        ? "receipt-orange"
                                                        : "receipt-white"
                                                }`} icon={<DownOutlined />} />
                                        </Dropdown>
                                    </Button.Group>
                                ) : (
                                     tx.type === "CREDIT" && (
                                    <Button
                                        className="receipt-button receipt-white"
                                        onClick={() => handleOpenReceipt(tx.amount.toFixed(2), tx.id, tx.datePosted)}
                                    >
                                        ↥ Receipt to a tenant
                                    </Button>)
                                )}


                            </div>

                            {tx.type === "DEBIT" && (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                    <Button className="receipt-button receipt-white" onClick={() => handleDismiss(tx.id)}>
                                        Dismiss
                                    </Button>
                                </div>)}


                            <div className="border rounded bg-light p-3 text-center" style={{ flex: 1 }}>
                                {tx.matchingDetails?.isMatched ? (
                                    <>
                                        <div className="text-muted">{tx.matchingDetails.tenantName}</div>
                                        <div>{tx.matchingDetails.propertyAddress}</div>
                                        <div>Rent of ${tx.matchingDetails.rentAmount}</div>

                                    </>
                                ) : tx.matchingDetails?.isSuggested ? (
                                    <>
                                        <div className="text-muted">{tx.matchingDetails.tenantName}</div>
                                        <div>{tx.matchingDetails.propertyAddress}</div>
                                        <div>Rent of ${tx.matchingDetails.rentAmount}</div>

                                    </>
                                ) : (
                                    <>
                                        <div className="text-muted">No match</div>
                                        <strong>${tx.amount.toFixed(2)}</strong>
                                    </>
                                )}
                            </div>

                        </div>

                    ))}

                    <NewTenantReceipt
                        visible={ppenAddNewReceipt}
                        onClose={closeReceipt}
                        receiptDetails={receiptDetails}
                        supplierValue={supplierValue}
                        tenantValue={tenantValue}
                        ePaymentModes={ePaymentModes}
                        selectedPaymentMode={selectedPaymentMode}
                        setSelectedPaymentMode={setSelectedPaymentMode}
                        optionSupplier={optionSupplier}
                        fetchingSupplier={fetchingSupplier}
                        debounceFetcherSupplier={debounceFetcherSupplier}
                        handleSearchSupplier={handleSearchSupplier}
                        handleClearSupplier={handleClearSupplier}
                        onSubmit={handleReceiptSubmit}
                        ToastRef={ToastRef}
                        Tenant={true}
                        initialAmount={selectedTransactionAmount}
                        transactionDate={date}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReconcileTransaction;
